import { useParams } from "react-router";
import { projectStepMap } from "./ProjectSteps";
import { capitalizeFirstLetter, writeDataLayer } from "utils/helpers";
import { useEffect } from "react";
import { useAppSelector } from "store/hooks";

const ProjectPage: React.FC = (props) => {
    //let { step } = props.match.params;
    const { step } = useParams();
    const authState = useAppSelector((state) => state.auth);

    useEffect(() => {
        writeDataLayer(step, authState);
    }, [step]);

    const projectStep = capitalizeFirstLetter(step);
    //const StepComponent = projectStepMap.ProjectStepHome;  // to do projectStepMap["ProjectStep" + step];
    // @ts-ignore
    const StepComponent = step ? projectStepMap["ProjectStep" + projectStep] : null;

    return (
        <>
            {StepComponent && <StepComponent {...props} />}
        </>
    )
}

export default ProjectPage;